import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../../services/api-service.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyProfileService {

  constructor(private _ApiService: ApiServiceService) { }

  GetCompanyProfile(id: string) {
    return this._ApiService.get(`${environment.apiUrl}/company-profile?company_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  UpdateColors(id: string, model: any) {
    return this._ApiService.put(`${environment.apiUrl}/companies-update-colors/${id}`, model)
      .pipe(catchError(this.handleError));
  }

  UpdateCompanyFiles(id: string, model: any) {
    return this._ApiService.post(`${environment.apiUrl}/companies-update-license-tax/${id}`, model)
      .pipe(catchError(this.handleError));
  }

  UpdateCompanyInfo(id: string, model: any) {
    return this._ApiService.put(`${environment.apiUrl}/companies-update-basic-info/${id}`, model)
      .pipe(catchError(this.handleError));
  }

  GetCities(model: any) {
    return this._ApiService.get(`${environment.apiUrl}/cities`, model)
      .pipe(catchError(this.handleError));
  }

  ChargeWallet(model: any) {
    return this._ApiService.post(`${environment.apiUrl}/payment-request`, model)
      .pipe(catchError(this.handleError));
  }

  GetPaymentProviders() {
    return this._ApiService.get(`${environment.apiUrl}/payment-methods`)
      .pipe(catchError(this.handleError));
  }
  ConfirmWalletTransAction(token: string) {
    return this._ApiService.put(`${environment.apiUrl}/payment-confirmation/${token}`)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }
}
